import { render, staticRenderFns } from "./GKInventory.vue?vue&type=template&id=6395bcca&scoped=true"
import script from "./GKInventory.vue?vue&type=script&lang=js"
export * from "./GKInventory.vue?vue&type=script&lang=js"
import style0 from "./GKInventory.vue?vue&type=style&index=0&id=6395bcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6395bcca",
  null
  
)

export default component.exports